import { Device } from '@weave/schema-gen-ts/dist/schemas/phone/devices/v2/devices.pb';
import { SipProfilesApiTypes } from '@frontend/api-sip-profile';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { BannerNotification } from '@frontend/design-system';
import { DeviceSettingsAccordion } from '../../../components/devices/device-settings';
import { DeviceSettingsIdSummary } from '../../../components/devices/device-settings/device-settings-id-summary';

type Props = {
  device: Device | undefined;
  sipProfiles: SipProfilesApiTypes.SipProfilesType | undefined;
  locationIds: string[];
  tenantId?: string;
};

export const DeviceSettingsById = ({ sipProfiles, device, locationIds, tenantId }: Props) => {
  const sipProfile = sipProfiles?.[0];
  const registration = sipProfile?.registration;
  const { t } = useTranslation('phone', { keyPrefix: 'devices' });

  return (
    <>
      {!sipProfile && (
        <BannerNotification
          message={t(
            '{{name}} does not have an assigned Session Initiation Protocol (SIP) profile. Please Call Weave Support.',
            { name: device?.name ?? 'This device' }
          )}
          status='error'
          css={{ marginBottom: theme.spacing(3), minWidth: 'fit-content' }}
        />
      )}
      <DeviceSettingsIdSummary registration={registration} device={device} />
      <DeviceSettingsAccordion locationIds={locationIds} sipProfile={sipProfile} device={device} tenantId={tenantId} />
    </>
  );
};
